exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr[data-v-f70fbcf2]:nth-child(2n){background-color:#fff}tr[data-v-f70fbcf2]:nth-child(odd){background-color:#dbdbdb}", ""]);

// exports
